// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-footer[data-v-48378ef6]{background-color:var(--v-background-dark-base)!important}", ""]);
// Exports
module.exports = exports;
